@let availableEntities = availableEntities$ | async;

<div class="w-100" [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <div class="w-100">
        <ng-select
            class="entity-input"
            [class.ng-select-fill]="!tableStyle"
            [formControl]="fc"
            [items]="availableEntities"
            [placeholder]="field.name"
            bindLabel="name"
            bindValue="id"
            appendTo="body">
            <ng-template ng-label-tmp let-item="item">
                <span>{{ item.name }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
                <div>{{ item.name }}</div>

                @if (item.outOfService === true) {
                    <div class="d-flex align-items-center justify-content-between w-100 text-muted small gap-2 mt-n4">
                        <span>Uit dienst: {{ item.enddate ?? item.begindate | date: 'EEE dd MMM YYYY' }}</span>
                    </div>
                }
            </ng-template>
        </ng-select>

        @let selectedEntity = availableEntities | byId: fc.value;

        @if (selectedEntity?.outOfService === true) {
            <div class="d-flex justify-content-between text-nowrap gap-2 text-muted small mt-n1">
                <span class="flex-ellipsis">
                    Uit dienst: {{ selectedEntity.enddate ?? selectedEntity.begindate | date: 'EEE dd MMM YYYY' }}
                </span>
            </div>
        }
    </div>

    <mat-error [control]="fc"></mat-error>
</div>

@if (!entity()?.use_once && hiring$ && fcHiringId) {
    <div class="w-100" [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
        <ng-select
            class="entity-input"
            [class.ng-select-fill]="!tableStyle"
            [formControl]="fcHiringId"
            placeholder="Inhuur"
            notFoundText="Configureer via Instellingen -> Inhuurbedrijven"
            appendTo="body">
            @for (hire of hiring$ | async; track hire.id) {
                <ng-option [value]="hire.id">
                    {{ hire.name }}
                </ng-option>
            }
        </ng-select>
    </div>

    @if (tableStyle && fcName) {
        <textarea [formControl]="fcName" matInput placeholder="Naam" cdkTextareaAutosize rows="1"></textarea>
    } @else {
        <mat-form-field class="w-100" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'">
            <mat-label>Naam</mat-label>

            <textarea [formControl]="fcName" matInput placeholder="Naam" cdkTextareaAutosize rows="1"></textarea>

            <mat-error [control]="fcName"></mat-error>
        </mat-form-field>
    }
}
